var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"text-white hero-section"},[_c('TheHeader'),_c('HeroContent'),_c('ProductCategory'),_c('ProdItems'),_c('HowWeWork'),_c('WhyChooseUs'),_c('DeliveryProcess'),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }